
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/which-claude-model-is-best-for-writing",
      function () {
        return require("private-next-pages/which-claude-model-is-best-for-writing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/which-claude-model-is-best-for-writing"])
      });
    }
  